"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSource = void 0;
const CacheManager_1 = require("./CacheManager");
const DataService_1 = require("./DataService");
var DataSource;
(function (DataSource) {
    DataSource[DataSource["Avatar"] = 0] = "Avatar";
    DataSource[DataSource["MediaMessage"] = 1] = "MediaMessage";
    DataSource[DataSource["FileMessage"] = 2] = "FileMessage";
})(DataSource = exports.DataSource || (exports.DataSource = {}));
class CachingDataService {
    constructor() {
        this._cache = new CacheManager_1.CacheManager();
        this._service = new DataService_1.DataService();
    }
    getData(src, key, totalBytes, chunkSize) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = yield this._cache.tryGet(src, key);
            if (!data) {
                data = yield this._service.getData(key, totalBytes, chunkSize);
                if (!data) {
                    return { kind: "notFound" };
                }
                yield this._cache.put(src, key, data);
            }
            return { kind: "success", data };
        });
    }
    putData(src, key, data, unchunked) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._cache.put(src, key, data);
            return this._service.putData(key, data, unchunked);
        });
    }
    scavengeCache() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._cache.scavenge();
        });
    }
}
const service = new CachingDataService();
exports.default = service;
